import Instance from '../../../utils/Axios';

const EditarTipoPeriodo = (ydata, id, show) => async (dispatch) => {
  await Instance()
    .put(`/tipoperiodos/${id}`, { ydata })
    .then(({ data }) => {
      dispatch({ type: 'PUT_TIPOPERIODO', payload: data });
      show('success', 'Tipo de período editado com sucesso!');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default EditarTipoPeriodo;
